import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { MARKS } from '@contentful/rich-text-types'
// libraries
import sanitizeHtml from 'sanitize-html'
// constants
import sanitizeHtmlConfig from '../../../constants/sanitizeHtmlConfig'
import './rich-text.scss'

// se usa sanitizeHtml para evitar que se inyecten ataques tipo XSS a el front

type RichTextType = {
	data: any
	classes?: string
	isContent?: boolean
}

const RichText: any = (props: RichTextType) => {
	const { data, isContent = false, classes = '' } = props

	if (!data) return new Error('RichText necesita data')

	// falta configurar estas opciones para ContentFull
	// https://www.contentful.com/developers/docs/javascript/tutorials/rendering-contentful-rich-text-with-javascript/
	const options = {
		renderMark: {
			[MARKS.BOLD]: (text: any) => `<strong>${text}</strong>`
		}
	}

	const catchDataJson = (json: any) => {
		if (!json) return
		if (typeof json !== 'object') return new Error('RichText necesita que json sea un objeto')
		return sanitizeHtml(documentToHtmlString(json, options), sanitizeHtmlConfig)
	}

	const text = isContent ? catchDataJson(data.json) : sanitizeHtml(data, sanitizeHtmlConfig)

	const createMarkup = () => ({
		__html: typeof text === 'string' ? text : ''
	})

	// dangerouslySetInnerHTML is a dangerous element, please read this documentation before to use it https://es.reactjs.org/docs/dom-elements.html
	return (
		<div className={`a-rich-text ${classes}`} dangerouslySetInnerHTML={createMarkup()} /> || null
	)
}

export default RichText
